import React from 'react';
import CreateIconComponent, { CreateIconComponentProps } from '../CreateIconComponent';

export const FreeCircle = ({
  title = 'Free',
  viewBox = '0 0 24 24',
  ...props
}: CreateIconComponentProps): JSX.Element => (
  <CreateIconComponent title={title} viewBox={viewBox} {...props}>
    <ellipse cx="32.2437" cy="32" rx="31.5966" ry="32" fill="#733658" />
    <path
      d="M60.4057 31.9997c0 15.7539-12.6097 28.5226-28.1617 28.5226-15.5519 0-28.16165-12.7687-28.16165-28.5226 0-15.7538 12.60975-28.52251 28.16165-28.52251 15.552 0 28.1617 12.76871 28.1617 28.52251Z"
      stroke="#fff"
      strokeWidth=".218045"
    />
    <path
      d="M13.635 37.1066h2.204v-4.37h5.0133v-1.9177H15.839v-2.2793h5.122v-1.9178h-7.326v10.4848ZM29.1296 37.1066h2.53l-2.3282-3.9927c1.1175-.2672 2.2661-1.2575 2.2661-3.1124 0-1.9492-1.3193-3.3797-3.4768-3.3797h-4.8426v10.4848h2.204v-3.7569h1.6142l2.0333 3.7569Zm.2173-7.1208c0 .8802-.6674 1.4461-1.5521 1.4461h-2.3127v-2.8923h2.3127c.8847 0 1.5521.5659 1.5521 1.4462ZM34.0277 37.1066h7.326v-1.9335h-5.1219v-2.4365h5.0133v-1.9177h-5.0133v-2.2793h5.1219v-1.9178h-7.326v10.4848ZM43.8528 37.1066h7.3259v-1.9335h-5.1219v-2.4365h5.0133v-1.9177h-5.0133v-2.2793h5.1219v-1.9178h-7.3259v10.4848Z"
      fill="#fff"
    />
  </CreateIconComponent>
);

export default FreeCircle;
